import amex from 'images/paymentMethods/amex.png'
import discover from 'images/paymentMethods/discover.png'
import elo from 'images/paymentMethods/elo.png'
import hipercard from 'images/paymentMethods/hipercard.png'
import mastercard from 'images/paymentMethods/mastercard.png'
import visa from 'images/paymentMethods/visa.png'
import jcb from 'images/paymentMethods/jcb.png'
import aura from 'images/paymentMethods/aura.png'
import diners from 'images/paymentMethods/diners.png'
import yapay from 'images/paymentMethods/yapay.png'
import defaultImage from 'images/paymentMethods/default.png'
import bradesco from 'images/paymentMethods/bradesco.png'
import itau from 'images/paymentMethods/itau.png'
import bancoDoBrasil from 'images/paymentMethods/bancoDoBrasil.png'

const DEFAULT_PAYMENT_METHOD = {
  name: 'Não identificado',
  image: defaultImage,
}

const BALANCE = {
  paymentMethod: 'pagamento_com_saldo',
  name: 'Saldo Yapay',
  image: yapay,
}

const CREDIT_CARDS_GETNET = [
  { paymentMethod: 'amex', name: 'American Express', image: amex },
]

const CREDIT_CARDS_YAPAY = [
  { paymentMethod: 'american_express', name: 'American Express', image: amex },
  { paymentMethod: 'discover', name: 'Discover', image: discover },
  { paymentMethod: 'elo', name: 'Elo', image: elo },
  { paymentMethod: 'hipercard', name: 'Hipercard', image: hipercard },
  { paymentMethod: 'mastercard', name: 'Mastercard', image: mastercard },
  { paymentMethod: 'visa', name: 'Visa', image: visa },
  { paymentMethod: 'jcb', name: 'JCB', image: jcb },
  { paymentMethod: 'aura', name: 'Aura', image: aura },
  { paymentMethod: 'diners', name: 'Diners', image: diners },
]

const PAYMENT_METHODS = [BALANCE, ...CREDIT_CARDS_GETNET, ...CREDIT_CARDS_YAPAY]

const BILLETS_CONFIG_GATEWAY = [
  {
    paymentMethod: 'itau_billet',
    name: 'Boleto Itaú',
    image: defaultImage,
  },
]

const TRANSFERS_CONFIG_GATEWAY = [
  {
    paymentMethod: 'bradesco_online_transference',
    name: 'Transferência Bradesco',
    image: bradesco,
  },
  {
    paymentMethod: 'itau_online_transference',
    name: 'Transferência Itaú',
    image: itau,
  },
  {
    paymentMethod: 'bb_online_transference',
    name: 'Transferência Banco do Brasil',
    image: bancoDoBrasil,
  },
]

const CREDIT_CARDS_GATEWAY = [...CREDIT_CARDS_YAPAY]

export default {
  DEFAULT_PAYMENT_METHOD,
  BALANCE,
  CREDIT_CARDS_GETNET,
  CREDIT_CARDS_YAPAY,
  PAYMENT_METHODS,
  BILLETS_CONFIG_GATEWAY,
  TRANSFERS_CONFIG_GATEWAY,
  CREDIT_CARDS_GATEWAY,
}
